import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, unref as _unref, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, withCtx as _withCtx, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-771337fe"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "checkout-page" }
const _hoisted_2 = {
  key: 0,
  class: "checkout-page__loader"
}
const _hoisted_3 = {
  key: 1,
  class: "checkout-page__content"
}
const _hoisted_4 = { class: "container" }
const _hoisted_5 = { class: "checkout-page__section" }
const _hoisted_6 = {
  key: 0,
  class: "checkout-page__section-loader"
}
const _hoisted_7 = {
  key: 1,
  class: "checkout-page__shipping-methods"
}
const _hoisted_8 = { class: "heading heading--3" }
const _hoisted_9 = { class: "checkout-page__shipping-method-cost" }
const _hoisted_10 = {
  key: 2,
  class: "checkout-page__shipping-info"
}
const _hoisted_11 = { class: "checkout-page__form-input" }
const _hoisted_12 = {
  key: 3,
  class: "checkout-page__shipping-info"
}
const _hoisted_13 = { class: "iconed-text" }
const _hoisted_14 = { class: "checkout-page__section" }
const _hoisted_15 = { class: "heading heading--3 checkout-page__section-title" }
const _hoisted_16 = { class: "checkout-page__form-input" }
const _hoisted_17 = { class: "checkout-page__form-input" }
const _hoisted_18 = { class: "checkout-page__section" }
const _hoisted_19 = { class: "heading heading--3 checkout-page__section-title" }
const _hoisted_20 = {
  key: 0,
  class: "checkout-page__section-loader"
}
const _hoisted_21 = {
  key: 1,
  class: "checkout-page__payment-methods"
}
const _hoisted_22 = { class: "checkout-page__section" }
const _hoisted_23 = { class: "heading heading--3 checkout-page__section-title" }
const _hoisted_24 = { class: "checkout-page__form-input" }

import AppHeader from '@/components/AppHeader.vue';
// eslint-disable-next-line import/no-cycle
import { useTelegramWebApp } from '@/services/telegram-web-app';
import { onMounted, ref, watch } from 'vue';
import router from '@/router';
import AppRadio from '@/components/AppRadio.vue';
import AppTextField from '@/components/AppTextField.vue';
import useShippingMethodsStore from '@/store/shipping-methods';
import usePaymentMethodsStore from '@/store/payment-methods';
import { phoneMask } from '@/app.config';
import AppLoader from '@/components/AppLoader.vue';
import {
  Coupon,
  Order,
  OrderCreateStockErrorDataItem,
  PaymentMethod,
  ShippingMethod,
} from '@/types/app';
import IconMapPin from '@/icons/icon-map-pin.vue';
import useAppConfigStore from '@/store/app-config';
import ApiRepository from '@/repositories/api';
import useCheckoutStore from '@/store/checkout';
import useProfileStore from '@/store/profile';
import { useI18n } from 'vue-i18n';
import { onUnmounted } from '@vue/runtime-core';
import useTopAlertsStore from '@/store/top-alerts';
import helpers from '@/helpers';
import { ResponseErrorTypes } from '@/types/api/common';
import AppAlert from '@/components/AppAlert.vue';


export default /*#__PURE__*/_defineComponent({
  __name: 'CheckoutPage',
  setup(__props) {

const topAlertStore = useTopAlertsStore();
const telegramWebApp = useTelegramWebApp();
const shippingMethodsStore = useShippingMethodsStore();
const paymentMethodsStore = usePaymentMethodsStore();
const appConfigStore = useAppConfigStore();
const checkoutStore = useCheckoutStore();
const profileStore = useProfileStore();
const i18n = useI18n();

const selectedShippingMethod = ref<ShippingMethod>();
const selectedPaymentMethod = ref<PaymentMethod>();
const customerName = ref<string>('');
const shippingAddress = ref<string>('');
const customerPhone = ref<string>('');
const coupon = ref<string>('');
const setProfileDataToFields = () => {
  customerName.value = `${profileStore.profile.firstname} ${profileStore.profile.lastname}`.trim();
  shippingAddress.value = profileStore.profile?.addresses?.[0]?.address || '';
  customerPhone.value = `+${profileStore.profile.telephone.trim().replaceAll(/\D/g, '')}`;
};
const createError = ref<string>();
const errorSectionEl = ref();

if (profileStore.isLoaded) {
  setProfileDataToFields();
} else {
  watch(profileStore, () => (profileStore.isLoaded ? setProfileDataToFields() : null));
}

const validateForm = (): boolean => {
  if (!selectedShippingMethod.value) {
    topAlertStore.showWarningAlert(i18n.t('errorChooseShippingMethod'));
    // telegramWebApp.showAlert(i18n.t('errorChooseShippingMethod'));
    return false;
  }
  console.log(shippingAddress.value, "  -  ",shippingAddress.value.length );
  if ((selectedShippingMethod.value?.needAddress ?? false) && shippingAddress.value.length === 0) {
    topAlertStore.showWarningAlert(i18n.t('errorChooseShippingAddress'));
    return false;
  }
  if (customerName.value.length === 0) {
    topAlertStore.showWarningAlert(i18n.t('errorEnterYourName'));
    return false;
  }
  if (customerPhone.value.length === 0) {
    topAlertStore.showWarningAlert(i18n.t('errorEnterYourPhone'));
    return false;
  }
  if (!selectedPaymentMethod.value) {
    topAlertStore.showWarningAlert(i18n.t('errorChoosePaymentMethod'));
    return false;
  }
  return true;
};

const onOrderBtnClick = async () => {
  if (!validateForm()) return;
  createError.value = undefined;
  telegramWebApp.showMainBtnProgress();
  document.querySelector('input:focus, textarea:focus')?.blur();
  let couponInfo: undefined|Coupon;
  if (coupon.value) {
    couponInfo = (await ApiRepository.checkCoupon(coupon.value))?.data;
    if (!couponInfo) {
      telegramWebApp.showAlert(i18n.t('errorCouponInvalidOrActivatedOrExpired'));
      telegramWebApp.hideMainBtnProgress();
      return;
    }
  }
  const response = await ApiRepository.createOrder({
    recipient: {
      phone: customerPhone.value,
      name: customerName.value,
    },
    paymentMethod: selectedPaymentMethod.value!.code,
    shippingMethod: selectedShippingMethod.value!.code,
    address: selectedShippingMethod.value!.needAddress ? shippingAddress.value : undefined,
    coupon: couponInfo?.code,
  });
  if (response?.error) {
    if (response?.error === ResponseErrorTypes.SOME_PRODUCT_NOT_IN_STOCK) {
      let msg = `${i18n.t('errorOrderNotInStock')}\n\n`;
      msg += (response?.data as OrderCreateStockErrorDataItem[])
        .map((e: OrderCreateStockErrorDataItem) => i18n.t('errorOrderNotInStockProduct', {
          productName: e.name,
          cartQuantity: e.cartQuantity,
          productQuantity: e.productQuantity,
        }))
        .join('\n\n');
      createError.value = msg.replaceAll('\n', '<br>');
      setTimeout(() => errorSectionEl.value.scrollIntoView({ behavior: 'smooth' }), 200);
      telegramWebApp.hideMainBtnProgress();
      return;
    }
    if (response?.error === ResponseErrorTypes.ERR_MIN_ORDER_AMOUNT) {
      let msg = `${i18n.$t('errorMinOrderAmount', {
              min_order_amount: helpers.formatCurrency( appConfigStore.config.min_order_amount ),
              })}\n\n`;
      createError.value = msg.replaceAll('\n', '<br>');
      setTimeout(() => errorSectionEl.value.scrollIntoView({ behavior: 'smooth' }), 200);
      telegramWebApp.hideMainBtnProgress();
      return;
    }
    telegramWebApp.hideMainBtnProgress();
    return;
  }
  const order = response?.data as Order;
  checkoutStore.changeOrder(order);
  if (couponInfo) {
    checkoutStore.changeCoupon(couponInfo);
  }
  telegramWebApp.hideMainBtnProgress();
  router.push({ name: 'checkout-confirm' });
};

onMounted(() => {
  telegramWebApp.showMainBtn(i18n.t('toConfirmOrder'), onOrderBtnClick);
});

onUnmounted(() => {
  telegramWebApp.removeMainBtnHandler(onOrderBtnClick);
});

watch(() => selectedShippingMethod.value?.code, (newCode) => {
  if (newCode === 'pickup') {
    shippingAddress.value = '';
  } else {
    shippingAddress.value = profileStore.profile?.addresses?.[0]?.address || '';
  }
}, { immediate: true });


return (_ctx: any,_cache: any) => {
  const _component_templat = _resolveComponent("templat")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(AppHeader, {
      title: _ctx.$t('orderCheckout'),
      "with-search": false
    }, null, 8, ["title"]),
    (!_unref(profileStore).isLoaded)
      ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
          _createVNode(AppLoader)
        ]))
      : (_openBlock(), _createElementBlock("div", _hoisted_3, [
          _createElementVNode("div", _hoisted_4, [
            _createElementVNode("div", _hoisted_5, [
              (_unref(shippingMethodsStore).isLoading)
                ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
                    _createVNode(AppLoader)
                  ]))
                : (_openBlock(), _createElementBlock("div", _hoisted_7, [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(shippingMethodsStore).methods, (method) => {
                      return (_openBlock(), _createElementBlock("div", {
                        key: method.code,
                        class: "checkout-page__shipping-method"
                      }, [
                        _createVNode(AppRadio, {
                          "model-value": selectedShippingMethod.value?.code === method.code,
                          "onUpdate:modelValue": (e) => e ? (selectedShippingMethod.value = method) : null
                        }, {
                          label: _withCtx(() => [
                            _createElementVNode("div", _hoisted_8, _toDisplayString(method.name), 1)
                          ]),
                          _: 2
                        }, 1032, ["model-value", "onUpdate:modelValue"]),
                        _createElementVNode("div", _hoisted_9, _toDisplayString(method.cost === 0 ? method.code === 'pickup' ? _ctx.$t('free') : ""  : `+ ${_unref(helpers).formatCurrency(method.cost)}`), 1)
                      ]))
                    }), 128))
                  ])),
              (selectedShippingMethod.value?.needAddress && selectedShippingMethod.value?.code !== 'pickup')
                ? (_openBlock(), _createElementBlock("div", _hoisted_10, [
                    _createElementVNode("div", _hoisted_11, [
                      _createVNode(AppTextField, {
                        label: _ctx.$t('shippingAddress'),
                        placeholder: _ctx.$t('enterShippingAddress'),
                        modelValue: shippingAddress.value,
                        "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((shippingAddress).value = $event)),
                        modelModifiers: { trim: true }
                      }, null, 8, ["label", "placeholder", "modelValue"])
                    ])
                  ]))
                : _createCommentVNode("", true),
              (selectedShippingMethod.value?.code === 'pickup')
                ? (_openBlock(), _createElementBlock("div", _hoisted_12, [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(appConfigStore).config.store.addresses, (address) => {
                      return (_openBlock(), _createElementBlock("div", {
                        key: address.address,
                        class: "checkout-page__shipping-pickup-address"
                      }, [
                        _createVNode(AppRadio, {
                          "model-value": shippingAddress.value === address.address,
                          "onUpdate:modelValue": (e) => e ? (shippingAddress.value = address.address) : null
                        }, {
                          label: _withCtx(() => [
                            _createElementVNode("div", _hoisted_13, [
                              _createVNode(IconMapPin),
                              _createTextVNode(" " + _toDisplayString(address.address), 1)
                            ])
                          ]),
                          _: 2
                        }, 1032, ["model-value", "onUpdate:modelValue"])
                      ]))
                    }), 128))
                  ]))
                : _createCommentVNode("", true)
            ]),
            _createElementVNode("div", _hoisted_14, [
              _createElementVNode("div", _hoisted_15, _toDisplayString(_ctx.$t('contactsData')), 1),
              _createElementVNode("div", _hoisted_16, [
                _createVNode(AppTextField, {
                  label: _ctx.$t('fullNameShorted'),
                  placeholder: _ctx.$t('enterFullNameShorted'),
                  modelValue: customerName.value,
                  "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((customerName).value = $event)),
                  modelModifiers: { trim: true }
                }, null, 8, ["label", "placeholder", "modelValue"])
              ]),
              _createElementVNode("div", _hoisted_17, [
                _createVNode(AppTextField, {
                  label: _ctx.$t('phoneNumber'),
                  placeholder: "+998",
                  mask: _unref(phoneMask),
                  modelValue: customerPhone.value,
                  "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((customerPhone).value = $event))
                }, null, 8, ["label", "mask", "modelValue"])
              ])
            ]),
            _createElementVNode("div", _hoisted_18, [
              _createElementVNode("div", _hoisted_19, _toDisplayString(_ctx.$t('payment')), 1),
              (_unref(paymentMethodsStore).isLoading)
                ? (_openBlock(), _createElementBlock("div", _hoisted_20, [
                    _createVNode(AppLoader)
                  ]))
                : (_openBlock(), _createElementBlock("div", _hoisted_21, [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(paymentMethodsStore).methods, (method) => {
                      return (_openBlock(), _createElementBlock("div", {
                        key: method.code,
                        class: "checkout-page__payment-method"
                      }, [
                        _createVNode(AppRadio, {
                          label: method.name,
                          "model-value": selectedPaymentMethod.value?.code === method.code,
                          "onUpdate:modelValue": (e) => e ? (selectedPaymentMethod.value = method) : null
                        }, null, 8, ["label", "model-value", "onUpdate:modelValue"])
                      ]))
                    }), 128))
                  ]))
            ]),
            _createElementVNode("div", _hoisted_22, [
              _createElementVNode("div", _hoisted_23, _toDisplayString(_ctx.$t('promocode')), 1),
              _createElementVNode("div", _hoisted_24, [
                _createVNode(AppTextField, {
                  label: _ctx.$t('enterPromocode'),
                  placeholder: _ctx.$t('enterPromocode'),
                  modelValue: coupon.value,
                  "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((coupon).value = $event)),
                  modelModifiers: { trim: true }
                }, null, 8, ["label", "placeholder", "modelValue"])
              ])
            ]),
            (createError.value)
              ? (_openBlock(), _createElementBlock("div", {
                  key: 0,
                  class: "checkout-page__section",
                  ref_key: "errorSectionEl",
                  ref: errorSectionEl
                }, [
                  _createVNode(AppAlert, {
                    type: "error",
                    circular: ""
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_templat, { innerHTML: createError.value }, null, 8, ["innerHTML"])
                    ]),
                    _: 1
                  })
                ], 512))
              : _createCommentVNode("", true)
          ])
        ]))
  ]))
}
}

})